import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Typo from 'constants/typography'
import { hasLocizeTranslation } from 'lib/utils/locize'
import Icon from 'components/common/icon'
import ICONS, { ICON_SIZE } from 'components/common/icon/const'
import styles from './product-size-guide-dialogs.scss'
import {
  getUpdatedAndAddedSizeInfoText,
  getUpdatedSizeInfoText,
  getAddedSizeInfoText,
} from './productSizeGuideDialogsUtilities'

const ProductSizeGuideDialogs = ({
  t,
  isSizeUpdated,
  isSizeAdded,
  updatedSizes,
  addedSizes,
}) => {
  const isUpdatedAndAddedSize = isSizeAdded && isSizeUpdated

  const getSizeInfo = () => {
    if (isUpdatedAndAddedSize) {
      return {
        infoTitle: hasLocizeTranslation(
          t,
          'PRODUCT_SIZE_UPDATE_GUIDE_DIALOGS_TITLE',
          'Size Updates',
        ),
        infoText: getUpdatedAndAddedSizeInfoText(t, updatedSizes, addedSizes),
      }
    }

    if (isSizeUpdated) {
      return {
        infoTitle: hasLocizeTranslation(
          t,
          'PRODUCT_SIZE_UPDATE_GUIDE_DIALOGS_TITLE',
          'Size Updates',
        ),
        infoText: getUpdatedSizeInfoText(t, updatedSizes),
      }
    }

    return {
      infoTitle: hasLocizeTranslation(
        t,
        'PRODUCT_SIZE_ADD_GUIDE_DIALOGS_TITLE',
        'New Sizes Added!',
      ),
      infoText: getAddedSizeInfoText(t, addedSizes),
    }
  }

  const sizeInfo = getSizeInfo()

  return (
    <React.Fragment>
      <style jsx>{styles}</style>
      <div className={clsx('product-size-guide-dialogs')}>
        <div className="product-size-guide-dialogs__icon">
          <Icon src={ICONS.measurementTape} size={ICON_SIZE.medium} />
        </div>
        <div>
          <div
            className={clsx(
              Typo.subtitle1,
              'product-size-guide-dialogs__title',
            )}
          >
            <span>{sizeInfo.infoTitle}</span>
          </div>
          {isUpdatedAndAddedSize ? (
            <span className={clsx(Typo.body2)}>
              <span>
                <ul style={{ listStyleType: 'disc', marginLeft: '25px' }}>
                  <li>{sizeInfo.infoText.updatedInfo}</li>
                  <li>{sizeInfo.infoText.addedInfo}</li>
                </ul>
              </span>
              {sizeInfo.infoText.miscellaneousText}
            </span>
          ) : (
            <span className={clsx(Typo.body2)}>
              <span style={{ whiteSpace: 'pre-line' }}>
                {sizeInfo.infoText}
              </span>
            </span>
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

ProductSizeGuideDialogs.defaultProps = {
  isSizeUpdated: false,
  isSizeAdded: false,
  updatedSizes: [],
  addedSizes: [],
}

ProductSizeGuideDialogs.propTypes = {
  // component props
  t: PropTypes.func.isRequired,
  isSizeUpdated: PropTypes.bool,
  isSizeAdded: PropTypes.bool,
  updatedSizes: PropTypes.arrayOf(PropTypes.string),
  addedSizes: PropTypes.arrayOf(PropTypes.string),
}

export default ProductSizeGuideDialogs
